





import { Currency } from "@/shared/models/currency";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

// ? this component is a helper to display currency set on tenant
// ? as to avoid all the ceremony of actions and getters

@Component
export default class CurrencyDisplay extends Vue {
  @Prop() value?: number;
  @Prop() currencyId?: number;

  @Getter("codebooks/currencies") currencies?: Currency[];
  @Getter("appParams/workingCurrency") workingCurrency?: Currency;

  @Action("codebooks/refreshCurrencies") refreshCurrencies?: () => Promise<
    void
  >;
  async created() {
    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      this.refreshCurrencies();
    }
  }

  get currency() {
    if (this.currencyId == undefined){
      return this.workingCurrency?.isoCode;
    }

    const currency = this.currencies?.find((c) => c.id === this.currencyId);
    return currency?.isoCode;
  }
}
